import React from 'react';
import DeferredProfileAvatar from './DeferredProfileAvatar';

const ComplaintProfileAvatar = (props) => <DeferredProfileAvatar {...props} size={64} />;

export default ComplaintProfileAvatar;
